var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./select-store.j2"] = require( "./select-store.j2" );
dependencies["./select-date-and-time.j2"] = require( "./select-date-and-time.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["help/templates/personal-stylist/preferred-location.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "core"),"genericEmailService.appointmentType"]));
frame.set("appointmentType", t_1, true);
if(frame.topLevel) {
context.setVariable("appointmentType", t_1);
}
if(frame.topLevel) {
context.addExport("appointmentType", t_1);
}
output += "\n";
var t_2;
t_2 = (runtime.contextOrFrameLookup(context, frame, "appointmentType") == "personalShopper"?true:false);
frame.set("isApparelAppointment", t_2, true);
if(frame.topLevel) {
context.setVariable("isApparelAppointment", t_2);
}
if(frame.topLevel) {
context.addExport("isApparelAppointment", t_2);
}
output += "\n<div class=\"o-row\">\n\n    <div class=\"o-column o-extra-small--12\">\n\n        <h2 class=\"c-personal-stylist__h2\">\n            ";
output += runtime.suppressValue((lineno = 7, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["personal-stylist_preferred-location"])), env.opts.autoescape);
output += "\n        </h2>\n\n    </div>\n\n</div>\n\n<div class=\"o-row\">\n\n    <div class=\"o-column o-extra-small--12\">\n\n        <div class=\"c-form__field\">\n\n            <fieldset>\n\n                <ul class=\"c-form-adjacent\">\n\n                    <li class=\"c-form-adjacent__li\">\n\n                        <input\n                            type=\"radio\"\n                            id=\"email\"\n                            class=\"c-form-adjacent__radio js-preferred-location-radio\" name=\"preferred_location\" value=\"Email\" data-preferred-location=\"Email\"\n                            ";
if(runtime.contextOrFrameLookup(context, frame, "isApparelAppointment")) {
output += " disabled ";
;
}
output += "} />\n\n                        <label for=\"email\" class=\"c-form-adjacent__label\">\n                            ";
output += runtime.suppressValue((lineno = 33, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["personal-stylist_email"])), env.opts.autoescape);
output += "\n                        </label>\n\n                    </li>\n\n                    <li class=\"c-form-adjacent__li\">\n\n                        <input\n                            type=\"radio\"\n                            id=\"phone\"\n                            class=\"c-form-adjacent__radio js-preferred-location-radio\" name=\"preferred_location\" value=\"Phone\" data-preferred-location=\"Phone\"\n                            ";
if(runtime.contextOrFrameLookup(context, frame, "isApparelAppointment")) {
output += " disabled ";
;
}
output += "}/>\n\n                        <label for=\"phone\" class=\"c-form-adjacent__label\">\n                            ";
output += runtime.suppressValue((lineno = 47, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["personal-stylist_phone"])), env.opts.autoescape);
output += "\n                        </label>\n\n                    </li>\n\n                    <li class=\"c-form-adjacent__li c-personal-stylist__last-radio\">\n\n                        <input\n                            type=\"radio\"\n                            id=\"in-store\"\n                            class=\"c-form-adjacent__radio js-preferred-location-radio\"\n                            name=\"preferred_location\"\n                            value=\"Instore\"\n                            data-preferred-location=\"Instore\" />\n\n                        <label for=\"in-store\" class=\"c-form-adjacent__label\">\n                            ";
output += runtime.suppressValue((lineno = 63, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["personal-stylist_in-store"])), env.opts.autoescape);
output += "\n                        </label>\n\n                    </li>\n\n                </ul>\n\n            </fieldset>\n\n        </div>\n\n    </div>\n\n</div>\n\n<div class=\"o-row\">\n\n    <div class=\"o-column o-extra-small--12 o-large--8 u-no-gutters\">\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"genericEmailService") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"genericEmailService")),"personalStylistLocation")) {
output += "\n\n            ";
var t_3;
t_3 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"genericEmailService")),"personalStylistLocation");
frame.set("preferredStylistLocation", t_3, true);
if(frame.topLevel) {
context.setVariable("preferredStylistLocation", t_3);
}
if(frame.topLevel) {
context.addExport("preferredStylistLocation", t_3);
}
output += "\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "preferredStylistLocation") == "Instore") {
output += "\n                ";
env.getTemplate("./select-store.j2", false, "help/templates/personal-stylist/preferred-location.j2", null, function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
t_4.render(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
output += t_5
output += "\n            ";
})});
}
output += "\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "preferredStylistLocation") == "Instore" || runtime.contextOrFrameLookup(context, frame, "preferredStylistLocation") == "Phone") {
output += "\n                ";
env.getTemplate("./select-date-and-time.j2", false, "help/templates/personal-stylist/preferred-location.j2", null, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
t_8.render(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
output += t_9
output += "\n            ";
})});
}
output += "\n\n        ";
;
}
output += "\n\n    </div>\n\n</div>\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["help/templates/personal-stylist/preferred-location.j2"] , dependencies)